import httpClient from './httpClient';
import axios from 'axios';

export default class Freebies {

    static actionSubmited(formData){
        let params = new FormData();
		// params.append( 'email', formData.email );
		// params.append( 'postID', formData.postid );
		// params.append( 'resource', formData.resource );
        // params.append( 'action', 'freebiesAjaxDownload' );
		// params.append( 'security', document.getElementById( 'security' ).value );

        return axios.post( settings.ajax_url, formData );
    }

}